import { FC } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import s from './CreativeCard.module.scss'

import { Creative } from 'types/creative'

import { useDownloadFile } from 'hooks/useDownloadFile'
import { useModal } from 'hooks/useModal'
import { useShowDropdown } from 'hooks/useShowDropdown'

import { advertiserDashboardApi } from 'api/advertiserDashboard-api'

import { DeleteIcon } from 'assets/icons/DeleteIcon'
import { DownloadIcon } from 'assets/icons/DownloadIcon'
import { EditIcon } from 'assets/icons/EditIcon'
import { InfoIcon } from 'assets/icons/InfoIcon'

import { Card } from 'components/UI/Card/Card'
import ConfirmMessage from 'components/UI/ConfirmMessage'
import { Dropmenu } from 'components/UI/Dropmenu/Dropmenu'

import { createCreativeDescription } from 'pages/MyCreatives/helpers/createCreativeDescription'

interface CreativeCardProps {
  item: Creative
  deleteCreative: (id: number) => void
}

const CreativeCard: FC<CreativeCardProps> = (props) => {
  const { item, deleteCreative } = props

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const { show, handleClose, handleOpen } = useModal()
  const { ref, showDropdown } = useShowDropdown()

  const openCreativeInfoModal = () => {
    navigate(`${item.id}/?${searchParams}`, { replace: true })
  }

  const editCreativeHandler = () => {
    navigate(`edit/${item.id}/?${searchParams}`, { replace: true })
  }

  const [downloadReport] = useDownloadFile({
    getData: () => advertiserDashboardApi.downloadReport(item.id, 'creative'),
  })

  return (
    <>
      <Card variant="secondary" onClick={openCreativeInfoModal} className={s.cardWrapper} testid="creative-card">
        <Card.Image height='14.063rem'>
          <img src={item.thumbnail} alt="" />
        </Card.Image>
        <Card.Info className={s.cardInfo}>
          <div className={s.info}>
            <Card.CroppedText>{item.name}</Card.CroppedText>
            <p className={s.infoDescription}>{createCreativeDescription(item)}</p>
          </div>
          <div className={s.buttonsWrapper}>
            <Dropmenu
              variant="secondary"
              show={showDropdown}
              cref={ref}
              items={[
                { icon: <InfoIcon />, title: 'Show Info', onClick: openCreativeInfoModal },
                { icon: <EditIcon />, title: 'Edit', onClick: editCreativeHandler },
                { icon: <DeleteIcon />, title: 'Delete', onClick: handleOpen },
                { icon: <DownloadIcon />, title: 'Download Report', onClick: () => downloadReport() },
              ]}
            />
          </div>
        </Card.Info>
      </Card>
      <>
        <ConfirmMessage
          isOpen={show}
          handleClose={handleClose}
          message={`Are you sure you want to delete the "${item.name}" creative?`}
          deleteItem={deleteCreative}
          id={item.id}
        />
      </>
    </>
  )
}

export default CreativeCard
